import { Button } from '@wework/dieter-ui'
import React from 'react'
import { useSidebar } from '../../hoc/withSidebar'

export default function EditPanelFooter({ space, onSave, history }) {
  const { closeSideBar } = useSidebar()
  return (
    <>
      <div
        style={{
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'flex-start',
          padding: '0px',
        }}
      >
        <div
          style={{
            width: '50%',
            marginTop: 34,
            display: 'flex',
            paddingTop: 16,
            bottom: '0%',
            left: '0%',
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'flex-start',
          }}
        >
          {space.reservable && '👋 You have unsaved changes.'}
        </div>
        <div
          style={{
            width: '50%',
            marginTop: 24,
            display: 'flex',
            // position: 'fixed',
            bottom: '0%',
            zIndex: 9999,
            paddingTop: 16,
            backgroundColor: 'white',
            left: '0%',
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'flex-end',
          }}
        >
          <div>
            <Button
              variant="contained"
              default
              size="small"
              onClick={() => closeSideBar()}
            >
              Cancel
            </Button>
            <Button
              variant="contained"
              primary
              onClick={onSave}
              size="small"
              style={{ marginLeft: 12 }}
            >
              Save
            </Button>
          </div>
        </div>
      </div>
    </>
  )
}
